<template>
    <div class="shopConfig">
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    修改地址设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_modify_address"
                            @change="saveChange('is_open_modify_address',is_open_modify_address)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启访客修改订单地址，默认不开启
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    未付款通知设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_non_payment_notice"
                            @change="saveChange('is_open_non_payment_notice',is_open_non_payment_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启未付款通知，默认不开启
            </div>
            <div class="module-item-title" v-if="is_open_non_payment_notice">
                未付款提示信息
            </div>
            <div class="shop-config-tips" v-if="is_open_non_payment_notice">给顾客推送未付款提示消息时附带的一段文字</div>
            <div class="online-base-content" v-if="is_open_non_payment_notice">
                <el-input
                        class="input-textarea"
                        type="textarea"
                        resize="none"
                        rows="4"
                        maxlength="255"
                        show-word-limit
                        @blur="saveChange('non_payment_content',non_payment_content)"
                        placeholder="请输入内容..."
                        v-model="non_payment_content">
                </el-input>
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    下单通知设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_order_notice"
                            @change="saveChange('is_open_order_notice',is_open_order_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启下单通知，默认不开启
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    发货通知设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_delivery_notice"
                            @change="saveChange('is_open_delivery_notice',is_open_delivery_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启发货通知，默认开启
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    到货通知设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_arrival_notice"
                            @change="saveChange('is_open_arrival_notice',is_open_arrival_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启到货通知，默认开启
            </div>
            <div class="module-item-title" v-if="is_open_arrival_notice">
                验收提示信息
            </div>
            <div class="shop-config-tips" v-if="is_open_arrival_notice">给顾客推送验收提示消息时附带的一段文字</div>
            <div class="online-base-content" v-if="is_open_arrival_notice">
                <el-input
                        class="input-textarea"
                        type="textarea"
                        resize="none"
                        rows="4"
                        maxlength="255"
                        show-word-limit
                        @blur="saveTips('acceptance_msg',acceptance_msg)"
                        placeholder="请输入内容..."
                        v-model="acceptance_msg">
                </el-input>
            </div>
        </div>

        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    注册发送通知消息设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_register_notice"
                            @change="saveChange('is_open_register_notice',is_open_register_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启注册发送通知消息，默认关闭
            </div>
            <div class="module-item-title" v-if="is_open_register_notice">
                注册之后给访客自动发送消息
            </div>
            <div class="shop-config-tips" v-if="is_open_register_notice">注册之后给访客自动发送消息</div>
            <div class="online-base-content" v-if="is_open_register_notice">
                <el-input
                        class="input-textarea"
                        type="textarea"
                        resize="none"
                        rows="4"
                        maxlength="255"
                        show-word-limit
                        @blur="saveChange('register_notice_content',register_notice_content)"
                        placeholder="请输入内容..."
                        v-model="register_notice_content">
                </el-input>
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title shop-config-title">
                <div>
                    退换货通知设置
                </div>
                <div class="shop-config-switch-btn">
                    <el-switch
                            v-model="is_open_order_refund_notice"
                            @change="saveChange('is_open_order_refund_notice',is_open_order_refund_notice)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="shop-config-tips">
                是否开启退换货发送通知消息，默认关闭
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "setting-shopconfig",
        data () {
            return {
                is_open_modify_address: 0,
                is_open_non_payment_notice:0,
                non_payment_content:'亲，您有一笔订单未付款~',
                is_open_order_notice: 0,
                is_open_delivery_notice: 1,
                is_open_arrival_notice: 1,
                acceptance_msg: '',
                register_notice_content: '',
                is_open_register_notice: 0,
                is_open_order_refund_notice: 0,
            }
        },
        mounted() {
            this.shopConfigHandler()
        },
        methods:{
            saveTips(name, value){
                this.$http.setAcceptanceMsgAPI({
                    value: value
                }).then(res => {
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                        this.shopConfigHandler()
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            saveChange(name, value){
                let postValue = ''
                if (value == false && name != 'non_payment_content') {
                    postValue = 0
                } else if(name == 'register_notice_content') {
                    postValue = value
                }else if(name == 'non_payment_content'){
                    postValue = value == '' ? '亲，您有一笔订单未付款~' : value
                }else {
                    postValue = 1
                }
                this.$http.saveConfigAPI({
                    name: name,
                    value: postValue
                }).then(res => {
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                        this.shopConfigHandler()
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            shopConfigHandler(){
                this.$http.getacceptanceMsgAPI().then(res => {
                    if(res.status == 1){
                        this.acceptance_msg = res.data.configValue
                    }
                })
                this.$http.shopConfig().then( res => {
                    if(res.status == 1){

                        let addrPermission = res.data.is_open_modify_address
                        let is_open_non_payment_notice = res.data.is_open_non_payment_notice
                        this.non_payment_content = res.data.non_payment_content ? res.data.non_payment_content :'亲，您有一笔订单未付款~'
                        let orderNoticePermission = res.data.is_open_order_notice
                        let deliveryNoticePermission = res.data.is_open_delivery_notice
                        let arrivalNoticePermission = res.data.is_open_arrival_notice
                        let is_open_register_notice = res.data.is_open_register_notice
                        this.register_notice_content = res.data.register_notice_content
                        let is_open_order_refund_notice = res.data.is_open_order_refund_notice

                        this.is_open_non_payment_notice = is_open_non_payment_notice==1?true:false
                        this.is_open_order_notice = orderNoticePermission == 1 ? true : false
                        this.is_open_delivery_notice = deliveryNoticePermission == 1 ? true : false
                        this.is_open_arrival_notice = arrivalNoticePermission == 1 ? true : false
                        this.is_open_register_notice = is_open_register_notice == 1 ? true : false
                        this.is_open_order_refund_notice = is_open_order_refund_notice == 1 ? true : false
                        if (addrPermission == 1) {
                            this.is_open_modify_address = true
                        } else {
                            this.is_open_modify_address = false
                        }


                    }
                })
            },
        }
    }
</script>

<style lang="scss">
.shopConfig{
    .shop-config-title {
        display: flex;

        .shop-config-switch-btn {
            margin-left: auto;
        }
    }

    .shop-config-tips {
        color: #999;
        font-size: 12px;
        padding: 12px 0 15px 0;
    }

}
</style>